import { KrCard } from '@/common/card/KrCard';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box, LinearProgress } from '@mui/material';
import { useEffect, useState } from 'react';
// import { useChatbotRegistration } from '../ai/ChatbotMgrContext';

/**
 * The core dashboard card component that registers itself to the Chatbot.
 */
export const DashboardCard = ({ title, description, module, plugin, reqParam, children, ...krCardProps }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!plugin) return;
    // A slower response to an earlier request must not overwrite the latest filters' data
    let stale = false;
    setLoading(true);
    rsrc
      .data(module, plugin, reqParam)
      .then((res) => {
        if (!stale) setData(res);
      })
      .finally(() => {
        if (!stale) setLoading(false);
      });
    return () => {
      stale = true;
    };
  }, [reqParam]);

  // useChatbotRegistration(title, description, { data: { module, plugin, reqParam } });

  return (
    <KrCard title={typeof title === 'function' ? title(data ?? {}) : title} {...krCardProps}>
      <Box sx={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column' }}>
        {loading && <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1 }} />}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            opacity: loading ? 0.5 : 1,
            transition: 'opacity 0.2s',
          }}
        >
          {data && children?.(data)}
        </Box>
      </Box>
    </KrCard>
  );
};
